// import { PlusOutlined } from "@ant-design/icons";
import { CloseOutlined } from "@ant-design/icons";
import { Empty, Table } from "antd";

// ----------------- START Content -----------------
export const renderContentList = ({
    t,
    columnsCurrent,
    columnsVerify,
    columnsRepair,
    columnsSuspended,
    allBankAccountData,
    loadingBankAccounts,
    tableParams,
    handleTableChange, // ลบ this. ออกถ้าเป็น Functional Component
    showModel,
    typeBank,
    statusBank,
}) => {
    // ต้องมีคำว่า return ตรงนี้
    let column = columnsCurrent
    let status = statusBank;
    if (status === "Delete" || status === "Banned") {
        column = columnsSuspended;
    }
    if (status === "Vault") {
        column = columnsRepair;
    }
    if (typeBank === "verifying_account") {
        column = columnsVerify;
    }
    return {
        tab1: renderTable(column, allBankAccountData, loadingBankAccounts, tableParams, t, handleTableChange, showModel),
        // tab2: renderTable(columnsVerify, allBankAccountData, loadingBankAccounts, tableParams, t, handleTableChange, showModel),
        // tab3: renderTable(columnsRepair, allBankAccountData, loadingBankAccounts, tableParams, t, handleTableChange, showModel),
        // tab4: renderTable(columnsSuspended, allBankAccountData, loadingBankAccounts, tableParams, t, handleTableChange, showModel),
    };
};

// สร้าง Helper Function เพื่อลด Code ที่ซ้ำซ้อน (Don't Repeat Yourself)
const renderTable = (columns, data, loading, params, t, onChange, showModel) => (
    <div className="body table-responsive">
        <Table
            // title={() => (<Button className="md-hiden" onClick={showModel}>
            //     <PlusOutlined /> {t("Add Bank")}
            // </Button>)}
            className="col-12 pl-0 pr-0"
            columns={columns}
            rowKey={(record) => record.id}
            onChange={onChange}
            dataSource={data}
            loading={loading}
            locale={{
                emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("No data")} />,
            }}
            pagination={{
                ...params.pagination,
                showSizeChanger: true,
                locale: { items_per_page: `/ ${t("paged")}` },
                showTotal: (total, range) => {
                    const currentPage = params.pagination.current;
                    const totalPages = Math.ceil(total / params.pagination.pageSize);
                    return (
                        <span>
                            <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                            <span style={{ marginLeft: 10 }}>
                                {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                            </span>
                        </span>
                    );
                },
            }}
            scroll={{ x: "max-content" }}
        />
    </div>
);

// ----------------- END Content -----------------




// ----------------- START Tab -----------------
export const renderTabtList = (t, counterAccount, statusBank, isSearching, total, debouncedFetcSearch) => [
    {
        key: "tab1",
        tab: !isSearching ? t("bank_account_list", { counter: counterAccount, status:  t(statusBank)}) : <code style={{ color: "transparent", fontSize: 12 }}>{t("พบข้อมูล", { counter: total || 0 })} <CloseOutlined onClick={() => debouncedFetcSearch()} className="hover" style={{ marginLeft: 5, cursor: "pointer", color: "#555" }} /> </code>,
    },
]
// ----------------- END Tab -----------------
